









import { Component, mixins } from '@niknevis/vue-modules'
import { FilterComponentsMixin } from '@/modules/common/filter/mixins/filterComponentsMixin'

@Component
export default class Radio extends mixins(FilterComponentsMixin) {
  protected default = []
}
